import { Dayjs } from 'src/helpers/dayjs';

import CalendarIcon from 'src/pages/PublicPages/components/CalendarIcon';

interface Props {
  eventDate: Dayjs;
}

export default function CalendarBlockContent({ eventDate }: Props) {
  return <CalendarIcon eventDate={eventDate} />;
}
